export const API = {
    general:
        (process.env.REACT_APP_CMS_URL ??
            'https://cms.bebelschule-zwickau.de') + '/api',
    img: process.env.REACT_APP_CMS_URL ?? 'https://cms.bebelschule-zwickau.de',
}
